import React from 'react';
import Box from 'components/UI/Box';

export const InlineDivider = () => (
  <Box p={1} style={{ display: 'inline-block' }}>
    |
  </Box>
);

export default InlineDivider;
